import { FilterByColumnQuery, numberFilterCondition } from '.'
import { getQFromQuery } from '../../utils'
import { FilterText, FilterTypes } from '../types'

export const generateQuery = ({
  sourceDataset,
  sourceColumn,
  filterType,
  filterTextType,
  filterNumberType,
  filterNumberFirst,
  filterNumberSecond,
  filterValue,
  withAs,
  from
}: FilterByColumnQuery) => {
  let where = ''
  const nextQNumber = getQFromQuery(withAs) + 1
  if (filterType === FilterTypes.Text && filterValue) {
    const likeOrNot = filterTextType === FilterText.Equal ? 'ILIKE' : 'NOT ILIKE'
    const orAnd = filterTextType === FilterText.Equal ? 'OR' : 'AND'
    where = filterValue.map((v) => `${sourceColumn} ${likeOrNot} '%${v}%'`).join(` ${orAnd} `)
  } else {
    where = numberFilterCondition({
      provider: sourceDataset?.providerId,
      sourceColumn,
      filterNumberType,
      filterNumberFirst,
      filterNumberSecond
    })
  }
  return where && from
    ? `${withAs},
__q${nextQNumber} AS (
\tSELECT * FROM ${from} WHERE ${where}
)
SELECT * FROM __q${nextQNumber}`
    : ''
}
